import React, {
  Fragment,
  useState,
  useEffect,
  useRef,
  useCallback,
} from "react";
import { useNavigate } from "react-router-dom";

import { useParams } from "react-router-dom";
import { Row, Col, Nav, Tab, Card, Dropdown, Badge } from "react-bootstrap";
import {
  FiUser,
  FiLink2,
  FiCalendar,
  FiEdit,
  FiBook,
  FiTarget,
  FiUpload,
  FiClipboard,
  FiLayers,
  FiAward,FiEye,
  FiShare2,
  FiClock,
} from "react-icons/fi";
import "../../../assets/css/onHover.css";
import "../../../assets/css/details.css";
import {
  addExaminationTemplate,
  getExaminationTemplateDetails,
  updateExaminationTemplateStatus,
  updateExaminationTemplate,
  deleteExaminationTemplate,
  updateApprovalRequest,
  getDepartmentList,
} from "../../../services/Users-services.js";
import {
  useSharedState,
  useGlobalState,
} from "../../../services/hostelConst.js";
import {
  getMasterActionStatusFieldName,
  showErrorMessages,
} from "../../../services/utilityFunctions.js";
import MasterTable from "../../../views/dashboard/widget/MasterTabel.js";
import MasterTable2 from "../../../views/dashboard/widget/MasterTabe2.js";
import { getLocalStorageData } from "../../../services/axiosComponent.js";
import DetailsPageNavigation from "../../../views/dashboard/widget/detailsPageNavigation.js";
import MasterActions from "../../../views/dashboard/widget/MasterActions.js";
import { getMethods } from "../../../services/utilityFunctions.js";
import {
  openModal,
  closeModal,
  updateIds,
} from "../../../services/redux/reducers/modalSlice.js";

import { addSection } from "../../../services/redux/reducers/sectionSlice.js";
import { useSelector, useDispatch } from "react-redux";
import AddExaminationTemplateForm from "./AddExaminationTemplateForm.js";
import { Button } from "antd";
import QuestionPaperViewer from "./QuestionPaperPreView.js";
import {
  getExaminationTemplateShareDetails,
  updateExaminationTemplateShareStatus,
  getExaminationTemplateShareList,
  deleteExaminationTemplateShare,
} from "../../../services/Users-services.js";
import ShareTemplateForm from "./addtemplateShare.js";
import ApproversTable from "../../../views/dashboard/widget/MasterApproving.js";

import GenericApprovalWorkflow from "./ApprovalFlow.js";
import {
  getApproversList,
  getApprovalRequestList,
  getApprovalRequestDetails,
  addApprovalRequest,
} from "../../../services/Users-services.js";
// Memoized tab content components to prevent unnecessary re-renders
const ShareTab = React.memo(
  (details) => (
   console.log("details", details),
    (
      <MasterTable
        tab1={"Examination"}
        tab2={"Template Share"}
        getTableData={getExaminationTemplateShareList}
        deleteRow={deleteExaminationTemplateShare}
        getList={getExaminationTemplateShareList}
   
        templateId={details.data._ID}
        details={details.data}
        AddForm={ShareTemplateForm}
        actions={{
          delete: true,
          edit: true,
        }}
      />
    )
  )
);


const SeriesTab = React.memo(() => (
  <Card className="border-0 shadow-sm">
    <Card.Body className="p-4">
      <div className="d-flex align-items-center mb-3">
        <FiClock className="text-success me-2" size={20} />
        <h5 className="mb-0">Series & Schedule</h5>
      </div>
      <p className="text-muted">
        Manage examination series, scheduling, and timetable configurations for
        this template.
      </p>

      <Row className="mt-4">
        <Col lg={6}>
          <div className="border rounded p-3 mb-3">
            <h6 className="fw-semibold mb-3 d-flex align-items-center">
              <FiCalendar className="me-2 text-primary" size={16} />
              Examination Series
            </h6>
            <p className="text-muted small mb-3">
              Create and manage examination series
            </p>
            <button className="btn btn-outline-primary btn-sm w-100">
              <FiCalendar className="me-2" size={14} />
              Create New Series
            </button>
          </div>
        </Col>
        <Col lg={6}>
          <div className="border rounded p-3 mb-3">
            <h6 className="fw-semibold mb-3 d-flex align-items-center">
              <FiClock className="me-2 text-warning" size={16} />
              Schedule Settings
            </h6>
            <p className="text-muted small mb-3">
              Configure timing and duration settings
            </p>
            <button className="btn btn-outline-warning btn-sm w-100">
              <FiClock className="me-2" size={14} />
              Set Schedule
            </button>
          </div>
        </Col>
      </Row>

      <div className="border rounded p-3 mt-3">
        <h6 className="fw-semibold mb-3">Upcoming Series</h6>
        <div className="text-center py-3">
          <FiClock size={32} className="text-muted mb-2" />
          <p className="text-muted mb-0">No series scheduled yet</p>
        </div>
      </div>
    </Card.Body>
  </Card>
));


const ExaminationTemplateDetailsPage = ({ navigate }) => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const modal = useSelector((state) => state.modal);
  const sectionDetails = useSelector((state) => state.section);
  var navigate = navigate;
  const [sharedState, setSharedState] = useSharedState();

  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [methods, setMethods] = useState({});
  const [activeTab, setActiveTab] = useState("share");

  const userId = getLocalStorageData("profileDetails")._ID;

  const fetchDetails = useCallback(
    async ({ id, isLoading = true }) => {
      if (isLoading) setLoading(true);

      const response = await getExaminationTemplateDetails(id);

      if (response.status === "success") {
        console.log("response", response.data);
        dispatch(openModal({data: response.data}));
  
        setMethods(getMethods("Examination", "Templates"));
        setDetails(response.data);
      } else {
        showErrorMessages({ data: response, navigate });
      }
      if (isLoading) setLoading(false);
    },
    [dispatch, navigate]
  );
  const handleApprovalSent = useCallback(() => {
    // Refresh the template details after approval is sent
    fetchDetails({ id: id, isLoading: false });
  }, [fetchDetails, id]);

  const isInitialMount = useRef(true);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    }
    fetchDetails({ id: id });
  }, [id, fetchDetails]);

  // Memoized tab change handler to prevent unnecessary re-renders
  const handleTabSelect = useCallback((selectedTab) => {
    setActiveTab(selectedTab);
  }, []);

  return (
    <Fragment>
      {loading ? (
        <center>
          <div className="spinner-border text-primary" role="status">
            <span className="">Loading...</span>
          </div>
        </center>
      ) : (
        <Tab.Container
          activeKey={activeTab}
          onSelect={handleTabSelect}
          id="examination-template-tabs"
        >
          <Row className="mb-3">
            <Row className="mb-1 pb-0">
              <Col lg="12" className="mb-0 pb-0">
                <Card
                  className="position-relative border-0 transition-all shadow-sm"
                  style={{ borderRadius: "1rem", transition: "0.3s" }}
                >
                  <Card.Body className="p-3 px-lg-4 py-lg-3 pe-1">
                    <Row className="">
                      {/* Left Section */}
                      <Col lg="9">
                        <div className="">
                          <DetailsPageNavigation
                            list={["Academic", "Examination Templates"]}
                          />
                          <div className="d-flex align-items-start gap-2 mb-1">
                            <h3
                              className="mb-0 fw-bold fs-4 text-truncate"
                              style={{
                                background:
                                  "linear-gradient(45deg, #2b2b2b, #4a4a4a)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                              }}
                            >
                              {details?.NAME}
                            </h3>
                            <Badge
                              bg=""
                              className=" mt-0"
                              style={{
                                padding: "4px 7px",
                                fontSize: "0.65rem",
                                fontWeight: "400",
                                backgroundColor:
                                  details?.["STATUS"] === "Published"
                                    ? "#e8f5e9"
                                    : details?.["STATUS"] === "Draft"
                                    ? "#fff3e0"
                                    : "#ffebee",
                                color:
                                  details?.["STATUS"] === "Published"
                                    ? "#2e7d32"
                                    : details?.["STATUS"] === "Draft"
                                    ? "#f57c00"
                                    : "#c62828",
                                borderRadius: "4px",
                                textTransform: "uppercase",
                                letterSpacing: "0.4px",
                              }}
                            >
                              {details?.["STATUS"]}
                            </Badge>
                          </div>
                          <p
                            className="text-muted mb-4"
                            style={{
                              fontSize: "0.875rem",
                              lineHeight: 1.5,
                              display: "-webkit-box",
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              opacity: 0.75,
                            }}
                          >
                            {details?.DESCRIPTION || "No Description available"}
                          </p>

                          {/* Key Details Section - Improved Layout */}
                          <div className="d-flex flex-wrap gap-4 mb-4">
                            {/* Subject Info */}
                            <div className="d-flex align-items-center hover-animation">
                              <div
                                className="d-flex align-items-center justify-content-center rounded-circle me-2"
                                style={{
                                  width: "24px",
                                  height: "24px",
                                  backgroundColor: "rgba(33, 150, 243, 0.15)",
                                }}
                              >
                                <FiBook
                                  style={{ color: "#1976D2", fontSize: "16px" }}
                                />
                              </div>
                              <div>
                                <div
                                  className="text-muted"
                                  style={{
                                    fontSize: "0.7rem",
                                    fontWeight: "600",
                                    textTransform: "uppercase",
                                    letterSpacing: "0.5px",
                                  }}
                                >
                                  Subject
                                </div>
                                <div
                                  className="fw-medium"
                                  style={{ fontSize: "0.8rem" }}
                                >
                                  {details?.SUBJECT || "N/A"}
                                </div>
                              </div>
                            </div>

                            {/* Class Info */}
                            <div className="d-flex align-items-center hover-animation">
                              <div
                                className="d-flex align-items-center justify-content-center rounded-circle me-2"
                                style={{
                                  width: "24px",
                                  height: "24px",
                                  backgroundColor: "rgba(156, 39, 176, 0.15)",
                                }}
                              >
                                <FiLayers
                                  style={{ color: "#7B1FA2", fontSize: "16px" }}
                                />
                              </div>
                              <div>
                                <div
                                  className="text-muted"
                                  style={{
                                    fontSize: "0.7rem",
                                    fontWeight: "600",
                                    textTransform: "uppercase",
                                    letterSpacing: "0.5px",
                                  }}
                                >
                                  Class
                                </div>
                                <div
                                  className="fw-medium"
                                  style={{ fontSize: "0.75rem" }}
                                >
                                  {details?.CLASS || "N/A"}
                                </div>
                              </div>
                            </div>

                            {/* Section Info */}
                            <div className="d-flex align-items-center hover-animation">
                              <div
                                className="d-flex align-items-center justify-content-center rounded-circle me-2"
                                style={{
                                  width: "24px",
                                  height: "24px",
                                  backgroundColor: "rgba(233, 30, 99, 0.15)",
                                }}
                              >
                                <FiClipboard
                                  style={{ color: "#C2185B", fontSize: "16px" }}
                                />
                              </div>
                              <div>
                                <div
                                  className="text-muted"
                                  style={{
                                    fontSize: "0.7rem",
                                    fontWeight: "600",
                                    textTransform: "uppercase",
                                    letterSpacing: "0.5px",
                                  }}
                                >
                                  Section
                                </div>
                                <div
                                  className="fw-medium"
                                  style={{ fontSize: "0.75rem" }}
                                >
                                  {details?.SECTION || "N/A"}
                                </div>
                              </div>
                            </div>

                            {/* Academic Year Info */}
                            <div className="d-flex align-items-center hover-animation">
                              <div
                                className="d-flex align-items-center justify-content-center rounded-circle me-2"
                                style={{
                                  width: "24px",
                                  height: "24px",
                                  backgroundColor: "rgba(255, 193, 7, 0.15)",
                                }}
                              >
                                <FiCalendar
                                  style={{ color: "#FFA000", fontSize: "16px" }}
                                />
                              </div>
                              <div>
                                <div
                                  className="text-muted"
                                  style={{
                                    fontSize: "0.7rem",
                                    fontWeight: "600",
                                    textTransform: "uppercase",
                                    letterSpacing: "0.5px",
                                  }}
                                >
                                  Academic Year
                                </div>
                                <div
                                  className="fw-medium"
                                  style={{ fontSize: "0.75rem" }}
                                >
                                  {details?.["ACADEMIC YEAR"] || "N/A"}
                                </div>
                              </div>
                            </div>

                            {/* Exam Type Info */}
                            <div className="d-flex align-items-center hover-animation">
                              <div
                                className="d-flex align-items-center justify-content-center rounded-circle me-2"
                                style={{
                                  width: "24px",
                                  height: "24px",
                                  backgroundColor: "rgba(76, 175, 80, 0.15)",
                                }}
                              >
                                <FiTarget
                                  style={{ color: "#388E3C", fontSize: "16px" }}
                                />
                              </div>
                              <div>
                                <div
                                  className="text-muted"
                                  style={{
                                    fontSize: "0.7rem",
                                    fontWeight: "600",
                                    textTransform: "uppercase",
                                    letterSpacing: "0.5px",
                                  }}
                                >
                                  Exam Type
                                </div>
                                <div
                                  className="fw-medium"
                                  style={{ fontSize: "0.75rem" }}
                                >
                                  {details?.["EXAM TYPE"] || "N/A"}
                                </div>
                              </div>
                            </div>

                            {/* Score Info */}
                            <div className="d-flex align-items-center hover-animation">
                              <div
                                className="d-flex align-items-center justify-content-center rounded-circle me-2"
                                style={{
                                  width: "24px",
                                  height: "24px",
                                  backgroundColor: "rgba(255, 87, 34, 0.15)",
                                }}
                              >
                                <FiAward
                                  style={{ color: "#D84315", fontSize: "16px" }}
                                />
                              </div>
                              <div>
                                <div
                                  className="text-muted"
                                  style={{
                                    fontSize: "0.7rem",
                                    fontWeight: "600",
                                    textTransform: "uppercase",
                                    letterSpacing: "0.5px",
                                  }}
                                >
                                  Total Score
                                </div>
                                <div
                                  className="fw-medium"
                                  style={{ fontSize: "0.75rem" }}
                                >
                                  {details?.SCORE || "0"} Points
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Tab Navigation */}
                          <Nav
                            as="ul"
                            className="nav-tabs mb-0 text-center"
                            data-toggle="slider-tab"
                            id="examination-template-tabs"
                            role="tablist"
                            style={{ fontSize: "0.8rem" }}
                          >
                            <Nav.Item as="li" className="me-2">
                              <Nav.Link
                                eventKey="share"
                                active={activeTab === "share"}
                                className="d-flex align-items-center gap-1 py-2 px-3"
                                style={{
                                  fontSize: "0.8rem",
                                  fontWeight: "500",
                                  minHeight: "auto",
                                }}
                              >
                                <FiShare2 size={14} />
                                <span className="d-none d-sm-inline">
                                  Share
                                </span>
                              </Nav.Link>
                            </Nav.Item>

                            <Nav.Item as="li" className="me-2">
                              <Nav.Link
                                eventKey="approvals"
                                active={activeTab === "approvals"}
                                className="d-flex align-items-center gap-1 py-2 px-3"
                                style={{
                                  fontSize: "0.8rem",
                                  fontWeight: "500",
                                  minHeight: "auto",
                                }}
                              >
                                <FiLink2 size={14} />
                                <span className="d-none d-sm-inline">
                                  Approvals
                                </span>
                              </Nav.Link>
                            </Nav.Item>

                            <Nav.Item as="li" className="me-2">
                              <Nav.Link
                                eventKey="series"
                                active={activeTab === "series"}
                                className="d-flex align-items-center gap-1 py-2 px-3"
                                style={{
                                  fontSize: "0.8rem",
                                  fontWeight: "500",
                                  minHeight: "auto",
                                }}
                              >
                                <FiClock size={14} />
                                <span className="d-none d-sm-inline">
                                  Series
                                </span>
                              </Nav.Link>
                            </Nav.Item>

                            <Nav.Item as="li" className="me-2">
                              <Nav.Link
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  window.open(
                                    `/examination/templates/preview-template/${id}`,
                                    "_blank"
                                  );
                                }}
                                className="d-flex align-items-center gap-1 py-2 px-3"
                                style={{
                                  fontSize: "0.8rem",
                                  fontWeight: "500",
                                  minHeight: "auto",
                                }}
                              >
                                <FiEye size={14} />
                                <span className="d-none d-sm-inline">
                                  Preview
                                </span>
                              </Nav.Link>
                            </Nav.Item>
                          </Nav>
                        </div>
                      </Col>

                      {/* Right Section */}
                      <Col lg="3" className=" ">
                        <div className="d-flex flex-column gap-1 justify-content-between  h-100">
                          <div className="d-flex align-items-center gap-1 p-1 hover-bg-light rounded-2 small ">
                            <div
                              className="bg-light rounded-circle p-1 me-2 d-flex align-items-center justify-content-center"
                              style={{ width: 28, height: 28 }}
                            >
                              <FiUser className="text-primary fs-6" />
                            </div>
                            <div>
                              <div
                                className={`text-dark fw-medium`}
                                style={{ fontSize: "0.875rem" }}
                              >
                                {details["CREATED BY"]}
                              </div>
                            </div>
                          </div>
                          <div className="d-flex align-items-center gap-1 p-1 hover-bg-light rounded-2 small">
                            <div
                              className="bg-light rounded-circle p-1 me-2 d-flex align-items-center justify-content-center"
                              style={{ width: 28, height: 28 }}
                            >
                              <FiCalendar className="text-success fs-6" />
                            </div>
                            <div>
                              <div
                                className={`text-dark fw-medium`}
                                style={{ fontSize: "0.875rem" }}
                              >
                                {details["LAST MODIFIED"]}
                              </div>
                            </div>
                          </div>
                          <div className="d-flex align-items-center gap-1 p-1 hover-bg-light rounded-2 small">
                            <div
                              className="bg-light rounded-circle p-1 me-2 d-flex align-items-center justify-content-center"
                              style={{ width: 28, height: 28 }}
                            >
                              <FiEdit className="text-warning fs-6" />
                            </div>
                            <div>
                              <div
                                className={`text-dark fw-medium`}
                                style={{ fontSize: "0.875rem" }}
                              >
                                {details["MODIFIED BY"]}
                              </div>
                            </div>
                          </div>
                          {
                            <div className="d-flex align-items-center gap-1 p-1 hover-bg-light rounded-2 small">
                              <div
                                className="bg-light rounded-circle p-1 me-2 d-flex align-items-center justify-content-center"
                                style={{ width: 28, height: 28 }}
                              >
                                <MasterActions
                                  actions={{
                                    edit:
                                      details["STATUS"] == "Draft" ||
                                      details["STATUS"] == "Rejected",

                                    delete:
                                      details["STATUS"] == "Draft" ||
                                      details["STATUS"] == "Rejected",
                                    status: false,
                                  }}
                                  publish={getMasterActionStatusFieldName(
                                    "Examination Template"
                                  )}
                                  title="Templates"
                                  AddForm={
                                    <AddExaminationTemplateForm
                                      navigate={navigate}
                                      refresh={() => {
                                        fetchDetails({
                                          id: id,
                                          isLoading: false,
                                        });
                                      }}
                                    />
                                  }
                                  refresh={() => {
                                    fetchDetails({
                                      id: id,
                                      isLoading: false,
                                    });
                                  }}
                                  methods={methods}
                                  deleteRow={deleteExaminationTemplate}
                                  updateStatus={updateExaminationTemplateStatus}
                                  updateRow={updateExaminationTemplate}
                                  isDetailsPage={true}
                                  item={details}
                                />
                              </div>
                              <div>
                                <div
                                  className={`text-dark fw-medium`}
                                  style={{ fontSize: "0.875rem" }}
                                >
                                  {"Show Options"}
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            {/* Tab Content */}
            <Row className="mt-0">
              <Col lg="12">
                <Tab.Content className="examination-template-content">
                  <Tab.Pane eventKey="share">
                    <ShareTab data={details} />
                  </Tab.Pane>

                  <Tab.Pane eventKey="series">
                    <SeriesTab />
                  </Tab.Pane>

                  <Tab.Pane eventKey="approvals">
                    <GenericApprovalWorkflow
                      entity={details}
                      entityId={id}
                      updateApprovalRequest={updateApprovalRequest}
                      entityType="EXAMINATION_TEMPLATE"
                      navigate={navigate}
                      onApprovalSent={handleApprovalSent}
                      getApproversList={getApproversList}
                      getApprovalRequestList={getApprovalRequestList}
                      getApprovalRequestDetails={getApprovalRequestDetails}
                      addApprovalRequest={addApprovalRequest}
                      approvalButtonText="Send Template for Approval"
                      modalTitle="Send Template for Approval"
                      isDraftField="STATUS"
                      draftValues={["Draft", "DRAFT"]}
                      showEntityInfo={true}
                    />
                  </Tab.Pane>
                </Tab.Content>
              </Col>
            </Row>
          </Row>
        </Tab.Container>
      )}
    </Fragment>
  );
};

export default ExaminationTemplateDetailsPage;
